it("should have correct error code", function() {
	try {
		require("./fail");
	} catch(e) {
		e.code.should.be.eql("MODULE_NOT_FOUND");
	}
});


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/missing-module-exception/index.js
 ** module id = 0
 ** module chunks = 0
 **/